import { Routes } from '@angular/router';
import { publicRoutes } from './routes/public.routes';
import { studentRoutes } from './routes/student.routes';
import { adminRoutes } from './routes/admin.routes';
import { mentorRoutes } from './routes/mentor.routes';
import { peerRoutes } from './routes/peer.routes';
import { schoolAdminRoutes } from './routes/school-admin.routes';
import { operationsRoutes } from './routes/operations.routes';
import { NotFoundComponent } from './not-found/not-found.component';

export const routes: Routes = [
  ...publicRoutes,
  ...studentRoutes,
  ...adminRoutes,
  ...mentorRoutes,
  ...peerRoutes,
  ...schoolAdminRoutes,
  ...operationsRoutes,
  { path: '**', component: NotFoundComponent }
];
